<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="300px"
    @keydown.esc="cancel()"
  >
    <v-system-bar
      dark
      dense
      :color="titleBackground"
    >
      <span class="white--text">Password</span>
    </v-system-bar>

    <v-card tile>
      <v-text-field
        label="Password"
        v-model="pwdIns"
        class="px-2 ma-0"
        hide-details
        type="password"
      ></v-text-field>

      <div
        style="height:35px; color:red;"
        class="px-2 overline"
      >{{errorMessage}}</div>

      <v-card-actions v-if="versione==1">
        <v-spacer></v-spacer>
        <v-btn
          @click.native="agree()"
          outline
        >OK</v-btn>
        <v-btn
          @click.native="cancel()"
          outline
        >Annulla</v-btn>
      </v-card-actions>
      <v-card-actions v-else-if="versione==2">
        <v-spacer></v-spacer>
        <v-btn
          @click.native="agree()"
          outlined
        >OK</v-btn>
        <v-btn
          @click.native="cancel()"
          outlined
        >Annulla</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EventBus } from "./passwordInputEventBus";

export default {
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      titleBackground: "",
      password: "",
      passwordParam: "",

      pwdIns: "",
      errorMessage: "",
    };
  },
  methods: {
    open() {
      this.pwdIns = "";
      this.errorMessage = "";

      this.dialog = true;
    },
    agree() {
      // Se ho passato la password come parametro alla funzione Open, uso quella
      let pwdCheck = this.passwordParam ? this.passwordParam : this.password;

      // Check pwd
      if (this.pwdIns != pwdCheck) {
        this.errorMessage = "Password non valida!";
        return;
      }

      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },

    handleConfirm(res, rej, pwd) {
      this.resolve = res;
      this.rej = rej;

      this.passwordParam = pwd;

      this.open();
    },
  },

  beforeMount() {
    // Impostazioni
    this.titleBackground = this.$pwdOptions.titleBackground;
    this.password = this.$pwdOptions.password;

    EventBus.$on("PwdOpen", this.handleConfirm);
  },

  beforeDestroy() {
    EventBus.$off("PwdOpen", this.handleConfirm);
  },

  computed: {
    versione() {
      return this.$waitOptions.version;
    },
  },
};
</script>